import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const initiativeCategoryApi = createApi({
  reducerPath: 'initiativeCategoriApi',
  baseQuery: rtkBaseQuery('/ticket/Project'),
  tagTypes: ['InitiativeCategori'],
  endpoints: (builder) => ({
    getAllInitiativeCategori: builder.query({
      query: () => '/GetInitiativeCategories',
      providesTags: ['InitiativeCategori'],
    }),
    createInitiativeCategori: builder.mutation({
      query: ({ nameUz, nameRu }) => ({
        url: '/CreateInitiativeCategory',
        method: 'POST',
        responseHandler: (response) => response.text(),
        params: { nameUz, nameRu },
      }),
      invalidatesTags: ['InitiativeCategori'],
    }),
    updateInitiativeCategori: builder.mutation({
      query: ({ id, nameUz, nameRu }) => ({
        url: `/EditInitiativeCategory?id=${id}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
        params: { id, nameUz, nameRu },
      }),
      invalidatesTags: ['InitiativeCategori'],
    }),
    deleteInitiativeCategori: builder.mutation({
      query: (id) => ({
        url: `/DeleteInitiativeCategory?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['InitiativeCategori'],
    }),
  }),
});

export const {
  useGetAllInitiativeCategoriQuery,
  useCreateInitiativeCategoriMutation,
  useUpdateInitiativeCategoriMutation,
  useDeleteInitiativeCategoriMutation,
} = initiativeCategoryApi;
